import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=6868e278&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868e278",
  null
  
)

export default component.exports